import {
    UPDATE_SIGN_IN_EMAIL,
    UPDATE_SIGN_IN_PASSWORD,
    SIGN_IN_SUCCEEDED,
    SIGN_OUT_SUCCEEDED,
    TWO_FA_CHALLENGE_ISSUED,
    TWO_FA_VERIFICATION_FAILED,
    CANCEL_TWO_FA,
} from 'shared_redux/actions';

const createDefaultState = () => ({
    email: "",
    password: "",
    twoFaChallengeId: null,
    twoFaEmail: null,
    twoFaError: null,
});

export default (state = createDefaultState(), action) => {
    switch (action.type) {
        case UPDATE_SIGN_IN_EMAIL:
            return {
                ...state,
                email: action.email
            };
        case UPDATE_SIGN_IN_PASSWORD:
            return {
                ...state,
                password: action.password
            };
        case TWO_FA_CHALLENGE_ISSUED:
            return {
                ...state,
                twoFaChallengeId: action.challengeId,
                twoFaEmail: action.email,
                twoFaError: null,
            };
        case TWO_FA_VERIFICATION_FAILED:
            return {
                ...state,
                twoFaError: action.message,
            };
        case CANCEL_TWO_FA:
            return {
                ...state,
                twoFaChallengeId: null,
                twoFaEmail: null,
                twoFaError: null,
            };
        case SIGN_IN_SUCCEEDED:
            return createDefaultState();
        case SIGN_OUT_SUCCEEDED:
            return createDefaultState();
        default:
            return state;
    }
};
